import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * A block of "related services" or "related solutions" tiles used at the
 * end of every inner page.
 */
export function RelatedTiles({ heading = "Also worth looking at", items }) {
  if (!items?.length) return null;
  return (
    <section className="bg-wafa-cream/40" data-testid="related-tiles">
      <div className="mx-auto max-w-7xl px-4 py-16 lg:px-6 lg:py-24">
        <h2 className="font-heading text-2xl font-semibold tracking-tight text-wafa-deep sm:text-3xl">
          {heading}
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {items.map((it) => (
            <Link
              key={it.to + it.label}
              to={it.to}
              data-testid={`related-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group flex items-start justify-between gap-4 rounded-lg border border-wafa-deep/10 bg-white p-5 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.25)]"
            >
              <div>
                {it.tag ? (
                  <div className="text-[10px] font-semibold uppercase tracking-wider text-wafa-primary">
                    {it.tag}
                  </div>
                ) : null}
                <div className="mt-1 font-heading text-base font-semibold text-wafa-deep group-hover:text-wafa-primary">
                  {it.label}
                </div>
                {it.desc ? <div className="mt-1 text-sm text-wafa-ink/70">{it.desc}</div> : null}
              </div>
              <ArrowRight className="mt-1 h-4 w-4 text-wafa-deep/60 transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
